import { HospitalBedIcon } from "assets/images";
import React from "react";

function HospitalBed() {
  return (
    <div className="w-full flex justify-center absolute bottom-0 bed-graphic">
      <img src={HospitalBedIcon} alt="...aa" className="w-[741.071428571px]" />
    </div>
  );
}

export default HospitalBed;
